// @flow
import React from 'react';
import Text from './Typography';

type Props = {
  selectedTypes?: [],
  onSelectFilter?: (type: string) => void,
  listItems: Object[],
  className?: string,
  name?: string,
  item?: any,
  selectedItems?: [],
  listItems?: [],
  translatedItem?: {}
}

class FilterButton extends React.Component {
  state = {
    hover: false
  }

  props: Props;

  render() {
    const { name, item, selectedItems, translatedItem, onSelectFilter } = this.props;
    const outline = 'is-outline-ship-cove';
    const bg = 'is-bg-ship-cove';
    const isSelected = selectedItems && selectedItems.includes(name || item);
    return (
      <button
        id={`records-filter-${item}`}
        className={`records-filter__item
        ${this.state.hover ? bg : ''}
        ${isSelected ? bg : outline}`}
        onClick={onSelectFilter}
        onMouseEnter={() => this.setState({ hover: true })}
        onMouseLeave={() => this.setState({ hover: false })}
        style={this.state.hover ? { backgroundColor: 'ship-cove' } : {}}
      >
        <Text span>{translatedItem || item}</Text>
        {isSelected && !name && <i className='icon is-x-small ic-close' />}
      </button>
    );
  }
}

const FilterList = (p) => (
  <ul className={'records-filter__list'}>
    {
      p.listItems && p.listItems.map((item, i) => {
        return (
          <li key={`${item}-${i}`}>
            <FilterButton
              item={item}
              translatedItem={p.translatedListItems ? p.translatedListItems[item] : null}
              selectedItems={p.selectedTypes}
              onSelectFilter={() => p.onSelectFilter(item)}
            />
          </li>
        );
      })
    }
  </ul>
);

export default FilterList;

export { FilterButton };



// WEBPACK FOOTER //
// ./src/components/shared/FilterList.js